
export default async function LoginActionHandler(json) {
    if(/^\/signin/i.test(window.location.pathname)) {
        try {
            document.getElementById("Username").value = json.username;
            document.getElementById("PasswordValue").value = json.password;
            document.getElementById("RememberMe").checked = json.rememberMe;
            setTimeout(() => {
                document.getElementById("submit-signin-local").click();
            }, 100);
            return {success: true};
        } catch (error) {
            return {success: false, error};
        }
    } else {
        return {success: false, error: new Error("Not on login page.")};
    }
}

